export default __webpack_public_path__ + "static/media/dolphin.1aaafd80.webp";